var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"lg":"4","cols":"12"}},[_c('splr-cat-create')],1),_c('v-col',{attrs:{"lg":"8","cols":"12"}},[_c('splr-cat-table')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }